import { render, staticRenderFns } from "./im-chat.vue?vue&type=template&id=53f0afac&scoped=true"
import script from "./im-chat.vue?vue&type=script&lang=js"
export * from "./im-chat.vue?vue&type=script&lang=js"
import style0 from "./im-chat.vue?vue&type=style&index=0&id=53f0afac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f0afac",
  null
  
)

export default component.exports